import request from '@/config/request';
import API from '@/config/domain';

export default {
  // 字典枚举值查询接口
  getDictDataByCode(params, callback) {
    return request(API.BASEAPI + 'rest/dict/getDictDataByCode', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 组织机构名称联想
  getPubOrganName(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubOrganInfo/getPubOrganName', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 部门名称联想
  getPubDeptName(params, callback) {
    return request(API.BASEAPI + 'rest/pubDeptInfo/getPubDeptName', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 菜单tab接口/支持授权应用下拉多选
  getAllAppInfo(params, callback) {
    return request(API.BASEAPI + 'rest/appManageInfo/getAllAppInfo', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 用户管理-新增用户-角色选择
  loadRoleList(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubUser/loadRoleList', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 行政区划-三级接口
  getAreaList(params, callback) {
    return request(API.BASEAPI + 'rest/area/getChildrenAreaInfoByParentId', 'post', params).then((data) => {
      callback(data);
    });
  },
  // 用户管理 - 所属机构
  queryPubOrganArea(params, callback) {
    return request(API.BASEAPI + 'rest/bsp/pubOrganInfo/queryPubOrganArea', 'post', params).then((data) => {
      callback(data);
    });
  },
};